/**
 * LogoScrollReveal - The ACTUAL Brightridge logo appears between sections
 * Straight lines, full logo visible
 * Scrolling DOWN = logo disappears (covered by next section)
 * Scrolling UP = logo reappears
 */

import { useEffect, useState, useRef } from 'react';

// Using the ACTUAL Brightridge logo image
const BRIGHTRIDGE_LOGO_URL = "/images/brightridge-logo-512.webp";

// Logo that appears fixed while content scrolls over it
export const LogoDivider = ({ 
  fillColor = "#0C0C0E",
  bgColor = "white",
}) => {
  const [scrollProgress, setScrollProgress] = useState(0);
  const containerRef = useRef(null);
  
  useEffect(() => {
    const handleScroll = () => {
      if (!containerRef.current) return;
      
      const rect = containerRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      const progress = Math.max(0, Math.min(1, 
        (windowHeight - rect.top) / (windowHeight + rect.height)
      ));
      
      setScrollProgress(progress);
    };
    
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div 
      ref={containerRef}
      className="relative w-full overflow-hidden h-[160px] md:h-[200px]"
    >
      {/* Background that matches the section above */}
      <div 
        className="absolute inset-0"
        style={{ backgroundColor: bgColor }}
      />
      
      {/* The FULL Brightridge logo - centered, scales down on mobile */}
      <div 
        className="absolute left-1/2 top-1/2 flex items-center justify-center w-[140px] h-[140px] md:w-[180px] md:h-[180px]"
        style={{
          transform: 'translate(-50%, -50%)',
          opacity: 0.3,
        }}
      >
        <img 
          src={BRIGHTRIDGE_LOGO_URL} 
          alt="Brightridge" 
          width="512"
          height="512"
          loading="lazy"
          decoding="async"
          className="w-full h-full object-contain"
        />
      </div>
      
      {/* The sliding "curtain" - STRAIGHT LINE, no angular peak */}
      <div 
        className="absolute left-0 right-0"
        style={{
          top: `${(1 - scrollProgress) * 100}%`,
          bottom: 0,
          backgroundColor: fillColor,
        }}
      />
    </div>
  );
};

// Keep for backwards compatibility
export const AnimatedWaveDivider = LogoDivider;
